import React, {SVGProps} from 'react';

import {ReactComponent} from '../../assets/svg/file-import-solid.svg';

export default (props: SVGProps<any>) => <ReactComponent {...props} />;
